import { Action } from "redux"
import { Concept, Workspace } from "../../models"
import { Pagination } from "../workspacelistpage"
import { ConceptFilter } from "./index"

export const INITIALIZE = "CONCEPTSPAGE_INITIALIZE"
export const SET_INITIALIZED = "CONCEPTSPAGE_SET_INITIALIZED"

export const initialize = (): Action => ({ type: INITIALIZE })

export const setInitialized = (): Action => ({ type: SET_INITIALIZED })

export const LOAD_MORE_CONCEPTS = "CONCEPTSPAGE_LOAD_MORE_CONCEPTS"

export const loadMoreConcepts = (): Action => ({ type: LOAD_MORE_CONCEPTS })

export const REQUEST_CONCEPTS = "CONCEPTSPAGE_REQUEST_CONCEPTS"
export const RECEIVE_CONCEPTS = "CONCEPTSPAGE_RECEIVE_CONCEPTS"
export const FILTER_CONCEPTS = "CONCEPTSPAGE_FILTER_CONCEPTS"

export const requestConcepts = (): Action => ({ type: REQUEST_CONCEPTS })

export interface ReceiveConcepts extends Action {
    concepts: Concept[]
}

export interface FilterConcepts extends Action {
    filter: ConceptFilter
}

export const receiveConcepts = (concepts: Concept[]): ReceiveConcepts => ({
    type: RECEIVE_CONCEPTS,
    concepts,
})

export const filterConcepts = (filter: ConceptFilter): FilterConcepts => ({
    type: FILTER_CONCEPTS,
    filter,
})

export const UPDATE_CREATE_CONCEPT_VISIBILITY =
    "CONCEPTSPAGE_UPDATE_CREATE_CONCEPT_VISIBILITY"

export interface UpdateCreateConceptVisibility extends Action {
    createConceptVisible: boolean
}

export const updateCreateConceptVisibility = (
    createConceptVisible: boolean,
): UpdateCreateConceptVisibility => ({
    type: UPDATE_CREATE_CONCEPT_VISIBILITY,
    createConceptVisible,
})

export const REQUEST_WORKSPACES = "CONCEPTSPAGE_REQUEST_WORKSPACES"
export const RECEIVE_WORKSPACES = "CONCEPTSPAGE_RECEIVE_WORKSPACES"
export const FILTER_WORKSPACES = "CONCEPTSPAGE_FILTER_WORKSPACES"
export const LOAD_MORE_WORKSPACES = "CONCEPTSPAGE_LOAD_MORE_WORKSPACES"

export interface ReceiveWorkspaces extends Action {
    pagination: Pagination
    workspaces: Workspace[]
}

export interface FilterWorkspaces extends Action {
    filter: string
}

export const requestWorkspaces = (): Action => ({ type: REQUEST_WORKSPACES })

export const receiveWorkspaces = (
    pagination: Pagination,
    workspaces: Workspace[],
): ReceiveWorkspaces => ({ type: RECEIVE_WORKSPACES, pagination, workspaces })

export const filterWorkspaces = (filter: string): FilterWorkspaces => ({
    type: FILTER_WORKSPACES,
    filter,
})

export const loadMoreWorkspaces = (): Action => ({ type: LOAD_MORE_WORKSPACES })

export const mapDispatchToProps = {
    initialize,
    setInitialized,
    loadMoreConcepts,
    requestConcepts,
    receiveConcepts,
    filterConcepts,
    updateCreateConceptVisibility,
    receiveWorkspaces,
    requestWorkspaces,
    filterWorkspaces,
    loadMoreWorkspaces,
}

export type DispatchProps = typeof mapDispatchToProps
